export * from './remitos-generar-page.component';
export * from './remitos-selector-productos-dialog';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-generar-page/index.ts